import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header block" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "company-name" }
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { class: "row basic" }
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "container block" }
const _hoisted_11 = { class: "table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_export_button = _resolveComponent("export-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, " 派遣单位名称：" + _toDisplayString(_ctx.insureProject.serveCompanyName), 1),
          _createElementVNode("div", null, " 方案：" + _toDisplayString(_ctx.insureProject.comboName), 1)
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_export_button, { onExport: _ctx.onExport }, null, 8, ["onExport"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "key" }, "投保人数：", -1)),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.insureProject.insurePeople) + "人", 1),
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "key" }, "费用总计：", -1)),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.insureProject.amount) + "元", 1),
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "key" }, "生效日期：", -1)),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.insureProject.beginCreateTime), 1),
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "key" }, "截止日期：", -1)),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.insureProject.endCreateTime), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_el_table, {
          data: _ctx.tableData,
          style: {"width":"100%"},
          "header-row-style": { color: '#202536' },
          "row-style": { color: '#5E617D' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "index",
              label: "序号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "userName",
              label: "姓名"
            }),
            _createVNode(_component_el_table_column, {
              prop: "idCardNo",
              label: "身份证号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "phone",
              label: "电话号码"
            }),
            _createVNode(_component_el_table_column, {
              prop: "amount",
              label: "保费"
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_el_pagination, {
          class: "pagination",
          currentPage: _ctx.pageNum,
          "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pageNum) = $event)),
          "page-size": _ctx.pageSize,
          "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pageSize) = $event)),
          "page-sizes": [10, 30, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: _ctx.total,
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
      ])
    ])
  ], 64))
}